export function AddExercise(organizationID: number, trainingCollectionID: number, exerciseID: number): string {
	return `/v1/organizations/${organizationID}/training-collections/${trainingCollectionID}/exercises/${exerciseID}`;
}

export function AddSession(organizationID: number, trainingCollectionID: number, sessionID: number): string {
	return `/v1/organizations/${organizationID}/training-collections/${trainingCollectionID}/sessions/${sessionID}`;
}

export function BulkAdd(organizationID: number, trainingCollectionID: number): string {
	return `/v1/organizations/${organizationID}/training-collections/${trainingCollectionID}/bulk-add`;
}

export function BulkRemove(organizationID: number, trainingCollectionID: number): string {
	return `/v1/organizations/${organizationID}/training-collections/${trainingCollectionID}/bulk-remove`;
}

export function BulkUpdateGroupShare(organizationID: number): string {
	return `/v1/organizations/${organizationID}/training-collections/group-share`;
}

export function BulkUpdateOrganizationShare(organizationID: number): string {
	return `/v1/organizations/${organizationID}/training-collections/share`;
}

export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/training-collections`;
}

export function Delete(organizationID: number, trainingCollectionID: number): string {
	return `/v1/organizations/${organizationID}/training-collections/${trainingCollectionID}`;
}

export function GroupShareIndex(organizationID: number, trainingCollectionID: number): string {
	return `/v1/organizations/${organizationID}/training-collections/${trainingCollectionID}/group-share`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/training-collections`;
}

export function RemoveExercise(organizationID: number, trainingCollectionID: number, exerciseID: number): string {
	return `/v1/organizations/${organizationID}/training-collections/${trainingCollectionID}/exercises/${exerciseID}`;
}

export function RemoveSession(organizationID: number, trainingCollectionID: number, sessionID: number): string {
	return `/v1/organizations/${organizationID}/training-collections/${trainingCollectionID}/sessions/${sessionID}`;
}

export function ShareIndex(organizationID: number, trainingCollectionID: number): string {
	return `/v1/organizations/${organizationID}/training-collections/${trainingCollectionID}/share`;
}

export function Show(organizationID: number, trainingCollectionID: number): string {
	return `/v1/organizations/${organizationID}/training-collections/${trainingCollectionID}`;
}

export function ShowExercises(organizationID: number, trainingCollectionID: number): string {
	return `/v1/organizations/${organizationID}/training-collections/${trainingCollectionID}/exercises`;
}

export function ShowSessions(organizationID: number, trainingCollectionID: number): string {
	return `/v1/organizations/${organizationID}/training-collections/${trainingCollectionID}/sessions`;
}

export function Update(organizationID: number, trainingCollectionID: number): string {
	return `/v1/organizations/${organizationID}/training-collections/${trainingCollectionID}`;
}

export function UpdateOrganizationShare(organizationID: number, trainingCollectionID: number): string {
	return `/v1/organizations/${organizationID}/training-collections/${trainingCollectionID}/share`;
}

